import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardActions, MatCardContent, MatCardHeader, MatCardTitle,} from '@angular/material/card';
import {MatDialog} from '@angular/material/dialog';
import {MatProgressBar} from '@angular/material/progress-bar';
import {RouterLink} from '@angular/router';
import {Client, ClientService} from '@app/admin/client.service';
import {InviteDialogComponent} from '@app/admin/invite-dialog/invite-dialog.component';
import {InviteUsersButtonComponent} from '@app/invitation/invite-users-button/invite-users-button.component';
import {User, UserService} from '@app/shared/user.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'frog-users-card',
    templateUrl: './users-card.component.html',
    styleUrls: ['./users-card.component.scss'],
    imports: [
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardContent,
        MatProgressBar,
        MatCardActions,
        InviteUsersButtonComponent,
        MatButton,
        RouterLink,
        AsyncPipe,
    ],
})
export class UsersCardComponent implements OnInit {
    public users$: Observable<User[]>;
    public client$: Observable<Client>;

    constructor(
        private userService: UserService,
        private clientService: ClientService,
        private matDialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.users$ = this.userService.users;
        this.client$ = this.clientService.client;
    }

    invite(clientId: string) {
        this.matDialog.open(InviteDialogComponent, {
            maxWidth: '900px',
            width: '100%',
            data: clientId,
        });
    }
}
